import { flatten, groupBy, sortBy } from 'es-toolkit/compat';

import type { UsageProduct } from '../../customerCenter/usage/redux/types';
import { sortRatePlans } from '../productSorter';

export function sortProducts(products: UsageProduct[]): UsageProduct[] {
    const groupedProducts = groupBy(sortBy(products, 'productName'), (product: UsageProduct) => product.productSku);
    return flatten(Object.values(groupedProducts).map((ratePlans: UsageProduct[]) => sortRatePlans(ratePlans)));
}
